export default __webpack_public_path__ + "static/media/right.d51e4c45.svg";